module.exports = __webpack_public_path__ + "img/txhy.5220ceb3.png";